// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d776e34c","703":"f4149d58","787":"b404e187"}[chunkId] + ".chunk.js";
};